import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

// PortalVerify now redirects to unified verify
// If there's a token in the URL, it redirects to /login/verify with the same token
export const PortalVerify = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    
    // Clear any old tokens first
    localStorage.removeItem('portal_token');
    localStorage.removeItem('portal_user');
    localStorage.removeItem('worker_token');
    localStorage.removeItem('client_token');
    localStorage.removeItem('admin_token');
    
    if (token) {
      // Redirect to unified verify with the same token
      navigate(`/login/verify?token=${token}`, { replace: true });
    } else {
      // No token, redirect to unified login
      navigate('/login', { replace: true });
    }
  }, [searchParams, navigate]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen ios-page flex items-center justify-center px-4">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#f47c2a] mx-auto mb-4 animate-spin" />
        <p className="text-[#1D1D1F] text-lg">Verificando acceso...</p>
      </div>
    </div>
  );
};
